.spinner {
  .spinnerPath1 {
    animation: path1Animation 0.8s ease-in-out infinite;
  }
  .spinnerPath2 {
    animation: path2Animation 0.8s ease-in-out infinite;
  }
  .spinnerPath3 {
    animation: path3Animation 0.8s ease-in-out infinite;
  }
  .spinnerPath4 {
    animation: path4Animation 0.8s ease-in-out infinite;
  }
  .spinnerPath5 {
    animation: path5Animation 0.8s ease-in-out infinite;
  }
  .spinnerPath6 {
    animation: path6Animation 0.8s ease-in-out infinite;
  }
  .spinnerPath7 {
    animation: path7Animation 0.8s ease-in-out infinite;
  }
  .spinnerPath8 {
    animation: path8Animation 0.8s ease-in-out infinite;
  }
}

@keyframes path1Animation {
  0% {
    opacity: 1;
  }
  12.5% {
    opacity: 0;
  }
  25% {
    opacity: 1;
  }
}

@keyframes path2Animation {
  12.5% {
    opacity: 1;
  }
  25% {
    opacity: 0;
  }
  37.5% {
    opacity: 1;
  }
}

@keyframes path3Animation {
  25% {
    opacity: 1;
  }
  37.5% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
}

@keyframes path4Animation {
  37.5% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  62.5% {
    opacity: 1;
  }
}

@keyframes path5Animation {
  50% {
    opacity: 1;
  }
  62.5% {
    opacity: 0;
  }
  75% {
    opacity: 1;
  }
}

@keyframes path6Animation {
  62.5% {
    opacity: 1;
  }
  75% {
    opacity: 0;
  }
  87.5% {
    opacity: 1;
  }
}

@keyframes path7Animation {
  75% {
    opacity: 1;
  }
  87.5% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes path8Animation {
  87.5% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
  0% {
    opacity: 0;
  }
  12.5% {
    opacity: 1;
  }
}
